import { render } from "./Checkbox.vue?vue&type=template&id=351a7812&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=351a7812&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351a7812"]])

export default __exports__